import { Alert, IconButton, Slide, Snackbar, duration } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import WarningIcon from '@mui/icons-material/Warning';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import React, { useEffect } from 'react'

const SnackbarPick = ({ message, open, setOpen, duration = 0, type }) => {
    const [colors, setColors] = React.useState({
        normal: {
            iconColor: '',
            textColor: '',
            backgroundColor: '',
            borderColor: '',
        },
        hover: {
            iconColor: '',
            textColor: '',
            backgroundColor: '',
            borderColor: '',
        },
        focused: {
            iconColor: '',
            textColor: '',
            backgroundColor: '',
            borderColor: '',
        },
    })

    const styles = {
        '& .MuiAlert-icon': {
            color: colors.normal.iconColor,
        },
        '& .MuiAlert-message': {
            color: colors.normal.textColor,
        },
        '& .MuiAlert-action': {
            color: colors.normal.textColor,
        },
        '& .MuiAlert-root': {
            backgroundColor: colors.normal.backgroundColor,
            border: `1px solid ${colors.normal.borderColor}`,
            '&:hover': {
                color: colors.hover.textColor,
                backgroundColor: colors.hover.backgroundColor,
                borderColor: colors.hover.borderColor,
                borderRadius: '8px',
                '& .MuiAlert-icon': {
                    color: colors.hover.iconColor,
                },
                '& .MuiAlert-message': {
                    color: colors.hover.textColor,
                },
                '& .MuiAlert-action': {
                    color: colors.hover.textColor,
                },
                '& .MuiAlert-root': {
                    backgroundColor: colors.hover.backgroundColor,
                    borderColor: colors.hover.borderColor,
                },
            }
        },
    };

    useEffect(() => {
        switch (type) {
            case 'success':
                setColors({
                    normal: {
                        iconColor: '#84D65A',
                        textColor: '#2B641E',
                        backgroundColor: '#EDFBD8',
                        borderColor: '#EDFBD8',
                    },
                    hover: {
                        iconColor: '#84D65A',
                        textColor: '#2B641E',
                        backgroundColor: '#EDFBD8',
                        borderColor: '#84D65A',
                    },
                    focused: {
                        iconColor: '#393A37',
                        textColor: '#2B641E',
                        backgroundColor: '#84D65A',
                        borderColor: '#84D65A',
                    },
                });
                break;
            case 'comunicate':
                setColors({
                    normal: {
                        iconColor: '#509AF8',
                        textColor: '#0C2A75',
                        backgroundColor: '#D7F1FD',
                        borderColor: '#D7F1FD',
                    },
                    hover: {
                        iconColor: '#509AF8',
                        textColor: '#0C2A75',
                        backgroundColor: '#D7F1FD',
                        borderColor: '#509AF8',
                    },
                    focused: {
                        iconColor: '#FFFFFF',
                        textColor: '#0C2A75',
                        backgroundColor: '#509AF8',
                        borderColor: '#509AF8',
                    },
                });
                break;
            case 'alert':
                setColors({
                    normal: {
                        iconColor: '#F7C752',
                        textColor: '#755118',
                        backgroundColor: '#FEF7D1',
                        borderColor: '#FEF7D1',
                    },
                    hover: {
                        iconColor: '#F7C752',
                        textColor: '#755118',
                        backgroundColor: '#FEF7D1',
                        borderColor: '#F7C752',
                    },
                    focused: {
                        iconColor: '#393A37',
                        textColor: '#393A37',
                        backgroundColor: '#F7C752',
                        borderColor: '#F7C752',
                    },
                });
                break;
            case 'error':
                setColors({
                    normal: {
                        iconColor: '#EF665B',
                        textColor: '#71192F',
                        backgroundColor: '#FCE8DB',
                        borderColor: '#FCE8DB',
                    },
                    hover: {
                        iconColor: '#EF665B',
                        textColor: '#71192F',
                        backgroundColor: '#FCE8DB',
                        borderColor: '#EF665B',
                    },
                    focused: {
                        iconColor: '#FFFFFF',
                        textColor: '#FFFFFF',
                        backgroundColor: '#EF665B',
                        borderColor: '#EF665B',
                    },
                });
                break;
            default:
                break;
        }
    }, [type]);

    const handleClose = () => {
        setOpen(false);
    }

    return (
        <Snackbar
            open={open}
            {...(duration !== 0 && { autoHideDuration: duration })}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            TransitionComponent={Slide}
            sx={styles}
            action={
                <React.Fragment>
                    <IconButton
                        size="small"
                        aria-label="close"
                        color="inherit"
                        onClick={handleClose}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </React.Fragment>
            }
        >
            <Alert
                onClose={handleClose}
                severity="success"
                variant="filled"
                icon={
                    (type === 'success') ? <CheckCircleRoundedIcon /> :
                    (type === 'comunicate') ? <InfoRoundedIcon /> :
                    (type === 'alert') ? <WarningIcon /> :
                    (type === 'error') ? <ErrorRoundedIcon /> : null
                }
                sx={{ width: '100%' }}
            >
                {message}
            </Alert>
        </Snackbar>
    )
}

export default SnackbarPick